export default {
  path: '/common-business',
  path_EN: '/common-business_EN',
  title: '基础业务',
  title_EN: 'Common Business',
  icon: 'mdi-cog',
  access: '基础业务',

  children: [
    {
      title: '船舶管理',
      icon: 'mdi-ship-wheel',
      group: '/ship',
      children: [
        {
          path: '/ship-info/list',
          name: 'common-ship-info-list',
          component: () =>
            import('@/views/common-business/ship-info/common-ship-info-list'),
          meta: {
            title: '船舶信息',
            access: '船舶信息:列表',
          },
        },
        {
          path: '/ship-info/detail/:id',
          name: 'common-ship-info-detail',
          component: () =>
            import('@/views/common-business/ship-info/common-ship-info-detail'),
          meta: {
            title: '船舶详情',
            access: '船舶信息:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/ship-certification/list',
          name: 'ship-certification-list',
          component: () =>
            import(
              '@/views/common-business/certification/ship-certification-list'
            ),
          meta: {
            title: '船舶证书',
            access: '船舶证书:列表',
          },
        },
        {
          path: '/ship-house/list',
          name: 'ship-house-list',
          component: () =>
            import('@/views/common-business/ship-house/ship-house-list'),
          meta: {
            title: '船舶仓库',
            access: '船舶仓库:列表',
          },
        },
        //手动录入
        {
          path: '/ship-carbin/list',
          name: 'carbin-list',
          component: () => import('@/views/common-business/carbin/carbin-list'),
          meta: {
            title: '船舱信息',
            access: '船舱信息:列表',
          },
        },
        //手动录入
        {
          path: '/ship-port/list',
          name: 'port-list',
          component: () => import('@/views/common-business/port/port-list'),
          meta: {
            title: '港口信息',
            access: '港口信息:列表',
          },
        },
        {
          path: '/ship-manage/list',
          name: 'common-ship-director',
          component: () =>
            import('@/views/common-business/ship-info/common-ship-director'),
          meta: {
            title: '船舶分管',
            access: '船舶分管:列表',
          },
        },
        {
          path: '/ship-manage-history',
          name: 'ship-manage-history',
          component: () =>
            import('@/views/common-business/ship-info/ship-manage-history'),
          meta: {
            title: '历史分管',
            access: '船舶分管历史信息:列表',
          },
        },
        {
          path: '/ship-manage-info',
          name: 'ship-manage-info',
          component: () =>
            import('@/views/common-business/ship-info/ship-manage-info'),
          meta: {
            title: '船舶归属',
            access: '船舶归属:列表',
          },
        },
        {
          path: '/ship-particular',
          name: 'ship-particular',
          component: () =>
            import('@/views/common-business/ship-info/ship-particular'),
          meta: {
            title: '船舶资料',
            access: '船舶资料:列表',
          },
        },
      ],
    },
    {
      title: '电子签名',
      title_EN: 'Electronic Signature',
      icon: 'mdi-pen',
      group: '/e-signature',
      children: [
        {
          path: '/e-signature/list',
          name: 'e-signature-list',
          component: () =>
            import('@/views/common-business/e-signature/e-signature-list'),
          meta: {
            title: '签名列表',
            title_EN: 'Electronic Signature List',
            access: '电子签名列表:列表',
          },
        },
      ],
    },
    {
      title: '编号规则',
      icon: 'mdi-counter',
      group: '/num-rules',
      children: [
        {
          path: '/num-rules/list',
          name: 'numbering-rules-list',
          component: () =>
            import(
              '@/views/common-business/numbering-rules/numbering-rules-list'
            ),
          meta: {
            title: '规则列表',
            access: '编号规则列表:列表',
          },
        },
      ],
    },
    {
      title: '货币汇率',
      icon: 'mdi-currency-usd',
      group: '/currency',
      children: [
        {
          path: '/currency/list',
          name: 'currency-list',
          component: () =>
            import('@/views/common-business/currency/currency-list'),
          meta: {
            title: '基础汇率',
            access: '货币汇率维护:列表',
          },
        },
        {
          path: '/currency/settlement-currency-list',
          name: 'settlement-currency-list',
          component: () =>
            import('@/views/common-business/currency/settlement-currency-list'),
          meta: {
            title: '结算汇率',
            access: '货币汇率维护:结算汇率列表',
          },
        },
      ],
    },
    {
      title: '供应商信息管理',
      icon: 'mdi-account-group',
      group: '/supplier',
      children: [
        {
          path: '/supplier/list',
          name: 'supplier-main-list',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '供应商列表',
            access: '供应商列表:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/supplier/detail/:id',
          name: 'supplier-detail',
          component: () =>
            import('@/views/common-business/supplier/supplier-detail'),
          meta: {
            title: '供应商详情',
            access: '供应商列表:列表',
            notShowInNav: true,
          },
        },
      ],
    },
    {
      title: '文件管理',
      icon: 'mdi-file',
      group: '/file',
      children: [
        {
          path: '/file/base-file-management',
          name: 'base-file-management',
          component: () =>
            import('@/views/common-business/file/base-file-management'),
          meta: {
            title: '文件列表',
            access: '文件信息管理:列表',
          },
        },
      ],
    },
    {
      title: '管船考评',
      title_EN: 'Manager Basic Business Volume',
      icon: 'mdi-pen',
      group: '/manager-work',
      children: [
        {
          path: '/manager-work/mech-ship-factor-score-standard',
          name: 'mech-ship-factor-score-standard',
          component: () =>
            import(
              '@/views/common-business/shipFactor/mech-ship-factor-score-standard'
            ),
          meta: {
            title: '机务系数标准',
            title_EN: 'Mech Ship Factor Score Standard',
            access: '机务船舶管理系数分数标准:列表',
          },
        },
        {
          path: '/manager-work/mech-ship-factor-record',
          name: 'mech-ship-factor-record',
          component: () =>
            import(
              '@/views/common-business/shipFactor/mech-ship-factor-record'
            ),
          meta: {
            title: '机务考评',
            title_EN: 'Mech Ship Factor Record',
            access: '机务船舶管理系数:列表',
          },
        },
        {
          path: '/manager-work/sea-ship-factor-score-standard',
          name: 'sea-ship-factor-score-standard',
          component: () =>
            import(
              '@/views/common-business/shipFactor/sea-ship-factor-score-standard'
            ),
          meta: {
            title: '海务系数标准',
            title_EN: 'Sea Ship Factor Score Standard',
            access: '海务船舶管理系数分数标准:列表',
          },
        },
        {
          path: '/manager-work/sea-ship-factor-record',
          name: 'sea-ship-factor-record',
          component: () =>
            import('@/views/common-business/shipFactor/sea-ship-factor-record'),
          meta: {
            title: '海务考评',
            title_EN: 'Sea Ship Factor Record',
            access: '海务船舶管理系数:列表',
          },
        },
      ],
    },
  ],
}
